"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MediaBlock = require("./MediaBlock.style");

var _ComponentWrapper = _interopRequireDefault(require("../ComponentWrapper"));

var _Typography = require("../Typography");

var MediaBlock = function MediaBlock(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      video = _ref.video,
      image = _ref.image,
      alt = _ref.alt,
      caption = _ref.caption,
      id = _ref.id,
      rest = _objectWithoutProperties(_ref, ["title", "subtitle", "video", "image", "alt", "caption", "id"]);

  var hasTitle = !!title;
  var hasSubitle = !!subtitle;
  var hasCaption = !!caption;
  var mediaProps = image ? _objectSpread(_objectSpread({
    alt: alt
  }, image), {}, {
    mediaType: 'image'
  }) : _objectSpread(_objectSpread({}, video), {}, {
    mediaType: 'video'
  });
  return /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, Object.assign({}, rest, {
    id: id
  }), title && /*#__PURE__*/_react.default.createElement(_Typography.PageTitle, {
    size: "medium"
  }, title), subtitle && /*#__PURE__*/_react.default.createElement(_MediaBlock.Subtitle, {
    size: "medium",
    hasTitle: hasTitle
  }, subtitle), /*#__PURE__*/_react.default.createElement(_MediaBlock.StyledMedia, Object.assign({}, mediaProps, {
    hasTitle: hasTitle,
    hasSubitle: hasSubitle,
    hasCaption: hasCaption
  })), caption && /*#__PURE__*/_react.default.createElement(_Typography.Body, {
    my: "small",
    size: "small"
  }, caption));
};

MediaBlock.propTypes = {
  id: _propTypes.default.string,
  image: _propTypes.default.shape(Object),
  video: _propTypes.default.shape(Object),
  alt: _propTypes.default.string,
  caption: _propTypes.default.string,
  title: _propTypes.default.string,
  subtitle: _propTypes.default.string
};
MediaBlock.defaultProps = {
  id: '',
  alt: '',
  caption: '',
  image: null,
  title: null,
  subtitle: null,
  video: null
};
var _default = MediaBlock;
exports.default = _default;